import cssString from "../styles/_minified/layouts-viewer.css"
import modalString from "../styles/_minified/modal.css"
import { CheckRes, LayoutState, PartData, UploadRes } from "../types/types"
import { hasErrors } from "../utils/checkLayoutErrors"
import { createChevronLeftIcon, createCloseIcon, createEllipsIcon, createInfoIcon, createLayout } from "../utils/createElemets"

// --------------------------------------------------------------------------------

export class LayoutsViewer extends HTMLElement {
    static observedAttributes = ["part-data-id", "index"]

    #partDataId?: string
    #layoutIndex: number
    #activeLayoutState?: LayoutState | null

    #modal: HTMLDivElement
    #container: HTMLDivElement

    constructor() {
        super()
        this.#layoutIndex = 0

        this.#modal = document.createElement('div')
        this.#container = document.createElement('div')
        this.#container.onclick = e => e.stopPropagation()
    }

    get #index() {
        return this.#layoutIndex
    }

    set #index(number) {
        this.#layoutIndex = number
        if (this.#partDataId)
            this.#activeLayout = layoutsState[this.#partDataId][number]
    }

    get #activeLayout() {
        return this.#activeLayoutState
    }

    set #activeLayout(activeLayout) {
        this.#activeLayoutState = activeLayout
        if (!activeLayout || !this.#partDataId) return
        this.#container.innerHTML = ''

        // ----------

        const layoutViewerHeader = document.createElement('div')
        layoutViewerHeader.classList.add('layout-viewer-header')
        const h3 = document.createElement('h3')
        h3.textContent = activeLayout.uploadResData.original_name
        const partDataName = document.createElement('span')
        partDataName.textContent = activeLayout.partData.name

        const subtitle = activeLayout?.partData.countPrintingSides === 2
            ? this.#index === 0
                ? 'Лицевая'
                : 'Оборотная'
            : undefined

        if (subtitle)
            partDataName.append(createEllipsIcon(), subtitle)

        layoutViewerHeader.append(h3, partDataName)

        if (hasErrors(activeLayout.checkResData)) {
            const error = document.createElement('div')

            const errorLink = document.createElement('button')
            errorLink.textContent = 'Смотреть замечания'
            errorLink.onclick = () => {
                if (!this.#partDataId) return

                const layoutErrorsModal = document.createElement('layout-errors-modal')
                layoutErrorsModal.setAttribute("part-data", this.#partDataId)
                layoutErrorsModal.setAttribute("index", `${this.#index}`)
                document.body.append(layoutErrorsModal)
            }

            error.append(
                createInfoIcon('error'),
                'Есть замечания, которые повлияют на результат',
                errorLink
            )
            layoutViewerHeader.append(error)
        }

        // ----------

        const layoutViewerActiveSlide = document.createElement('div')
        layoutViewerActiveSlide.classList.add('layout-viewer-active-slide')
        const activeLayoutContainer = createLayout(activeLayout)
        activeLayoutContainer.classList.add('active')

        const prev = document.createElement('button')
        prev.classList.add('prev')
        prev.append(createChevronLeftIcon())
        prev.onclick = () => {
            if (!this.#partDataId) return
            if (activeLayout.index - 1 >= 0)
                this.#activeLayout = layoutsState[this.#partDataId][activeLayout.index - 1]
        }

        const next = document.createElement('button')
        next.classList.add('next')
        next.append(createChevronLeftIcon())
        next.onclick = () => {
            if (!this.#partDataId) return
            if (activeLayout.index + 1 < layoutsState[this.#partDataId].length)
                this.#activeLayout = layoutsState[this.#partDataId][activeLayout.index + 1]
        }

        layoutViewerActiveSlide.append(activeLayoutContainer, prev, next)

        // ----------

        const layoutViewerSlides = document.createElement('div')
        layoutViewerSlides.classList.add('layout-viewer-slides')
        layoutsState[this.#partDataId].map((layoutState, index) => {
            if (!layoutState) return

            const slide = document.createElement('div')
            slide.classList.add('slide')
            if (index === activeLayout.index)
                slide.classList.add('active')

            const printingSides = layoutState?.partData.countPrintingSides
            if (this.#partDataId && layoutsState[this.#partDataId].length > 1) {
                const span = document.createElement('span')
                span.append(printingSides && printingSides > 1
                    ? index < 2
                        ? index === 0
                            ? 'Лицевая'
                            : 'Оборотная'
                        : ''
                    : '')
                slide.append(span)
            }

            const layout = createLayout(layoutState)
            layout.onclick = () => this.#activeLayout = layoutState

            slide.append(layout)
            layoutViewerSlides.append(slide)
        })

        // ----------
        const closeBtn = document.createElement('button')
        closeBtn.classList.add('close')
        closeBtn.append(createCloseIcon('var(--gray-800, #2D3748)'))
        closeBtn.onclick = () => this.closeModal()
        this.#container.append(layoutViewerHeader, layoutViewerActiveSlide, layoutViewerSlides, closeBtn)
    }

    closeModal() {
        this.#modal.classList.remove('visible')
        setTimeout(() => this.remove(), 300)
    }

    connectedCallback() {
        const shadow = this.attachShadow({ mode: "open" })

        const sheet = new CSSStyleSheet()
        sheet.replaceSync(cssString + modalString)
        shadow.adoptedStyleSheets = [sheet]

        this.#modal.classList.add('layout-viewer-container')
        this.#modal.onclick = e => {
            e.stopPropagation()
            this.closeModal()
        }

        this.#modal.append(this.#container)
        shadow.append(this.#modal)

        setTimeout(() => this.#modal.classList.add('visible'))
        layoutsViewerModal = this
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        switch (name) {
            case 'part-data-id':
                if (newValue)
                    this.#partDataId = newValue
                break

            case 'index':
                if (newValue)
                    this.#index = +newValue
                break

            default:
                break
        }
    }

    disconnectedCallback() {
        layoutsViewerModal = null
    }

}

customElements.define("layouts-viewer", LayoutsViewer)